import React, { useCallback } from 'react';
import { Box, Flex, Slider, SliderFilledTrack, SliderThumb, SliderTrack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { VolumeOff, VolumeLow, VolumeMed, VolumeHigh } from '../../../images';
import { updateSettings } from '../../../redux/reducers';

const VolumeControl = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const volume = useSelector((state) => state.settings.volume);
  const onChange = useCallback(
    (value) => {
      dispatch(updateSettings({ volume: value }));
      const audioElements = document.getElementsByTagName('audio');
      for (const elem of audioElements) {
        elem.volume = value;
      }
    },
    [dispatch]
  );

  return (
    <Flex mx={2} {...props}>
      {t('footer.volume')}
      <Box ml="2" width="36px">
        {volume <= 0 ? (
          <VolumeOff />
        ) : volume <= 0.33 ? (
          <VolumeLow />
        ) : volume <= 0.66 ? (
          <VolumeMed />
        ) : (
          <VolumeHigh />
        )}
      </Box>
      <Slider value={volume} min={0.0} max={1.0} step={0.01} onChange={onChange} width="10vw">
        <SliderTrack>
          <SliderFilledTrack />
        </SliderTrack>
        <SliderThumb />
      </Slider>
    </Flex>
  );
};

export default VolumeControl;
